<template>
  <v-tooltip bottom content-class="tooltip-dark">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon id="mode-switcher" :ripple="false" class="notification-btn" v-bind="attrs" v-on="on"
        @click="changeTheme">
        <v-icon v-if="loading" class="rotating ml-2 mb-0.5" size="large" color="#708AA7">
          mdi-loading
        </v-icon>
        <v-icon v-else :color="$vuetify.theme.dark ? 'greenMain' : '#d49e00'">
          {{ $vuetify.theme.dark ? "mdi-weather-sunny" : "mdi-weather-night" }}
        </v-icon>
      </v-btn>
    </template>
    <span class="tooltip-text">Switch Theme</span>
  </v-tooltip>
</template>

<script>
import { PROFILE__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      loading: false,
    };
  },

  watch: {
    client: {
      handler(val) {
        if (val && val.theme_preference !== undefined) {
          this.$vuetify.theme.dark = val.theme_preference === 1;
        }
      },
      immediate: true,
    },
  },

  computed: {
    ...mapState("profile", ["client"]),
  },

  methods: {
    ...mapActions("profile", [PROFILE__ACTIONS.CHANGETHEME]),

    async changeTheme() {
      this.loading = true;
      try {
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
        const res = await this[PROFILE__ACTIONS.CHANGETHEME]({ id: this.client?.id });
      } catch (error) {
        console.error("Theme toggle failed:", error);
      } finally {
        this.loading = false;
      }
    }

  },
};
</script>

<style scoped>
.grey-back {
  color: rgba(87, 125, 158, 0.342);
  background: transparent;
  margin: 0 !important;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.rotating {
  animation: spin 1s linear infinite;
}

.circle-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
